import React from 'react';
import { NavLink } from 'react-router-dom';

export default function PageNavigation() {
    return (
        <ul className="navigation-tabs__list">
            <li className="navigation-tabs__list-item">
                <NavLink
                    to="defaults"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    Defaults
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to="email-drivers"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    Email drivers
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to="sms-drivers"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    SMS drivers
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to="slack-drivers"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    Slack drivers
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to="push-drivers"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    Push drivers
                </NavLink>
            </li>
        </ul>
    );
}
